import { Component, Injectable, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { MenuController } from '@ionic/angular';

@Component({
  selector: 'app-segment-admin',
  templateUrl: './segment-admin.component.html',
  styleUrls: ['./segment-admin.component.scss'],
})

@Injectable({
  providedIn: 'root',
})

export class SegmentAdminComponent{
  @Input() nameMain = 'adminMain';
  @Output() emitSelectedConf = new EventEmitter<string>();
  constructor(
    private menu: MenuController,
    private router: Router,
  ) { }

  async goTo(dir) {
    await this.menu.close();
    const mainState = await this.menu.isOpen();
    await this.router.navigate([dir]);
  }

  async openFirst() {
    // const lg = await this.menu.toggle();
    // if(lg) {
      if (await this.menu.isOpen()) {
        // await this.menu.enable(true, );
        await this.menu.close();
      }else {
        await this.menu.toggle();
      }
    // }
  }

  getCurrencies(ev){
    this.emitSelectedConf.emit(ev)
  }
}
